export const LOGIN = {
    TRY_LOGIN: 'TRY_LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    GET_LOGIN_DATA: 'GET_LOGIN_DATA',
    GET_LOGIN_DATA_SUCCESS: 'GET_LOGIN_DATA_SUCCESS',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    VERIFY_OTP: 'VERIFY_OTP',
    VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
};

export const USERS = {
    GET_USERS: 'GET_USERS',
    GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
    GET_REPORT_USERS: 'GET_REPORT_USERS',
    REPORT_USERS_SUCCESS: 'REPORT_USERS_SUCCESS',
    GET_ADMIN_USERS: 'GET_ADMIN_USERS',
    GET_ADMIN_USERS_SUCCESS: 'GET_ADMIN_USERS_SUCCESS',
    GET_USER_PROFILE: 'GET_USER_PROFILE',
    USER_PROFILE_SUCCESS: 'USER_PROFILE_SUCCESS',
    SUSPEND_ACCOUNT: 'SUSPEND_ACCOUNT',
    SUSPEND_ACCOUNT_SUCCESS: 'SUSPEND_ACCOUNT_SUCCESS',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
    ADD_USER: 'ADD_USER',
    ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
    GET_USERS_LOCATIONS: 'GET_USERS_LOCATIONS',
    GET_USERS_LOCATIONS_SUCCESS: 'GET_USERS_LOCATIONS_SUCCESS',

    GET_FOLLOWERS: 'GET_FOLLOWERS',
    GET_FOLLOWERS_SUCCESS: 'GET_FOLLOWERS_SUCCESS',
    GET_FOLLOWING: 'GET_FOLLOWING',
    GET_FOLLOWING_SUCCESS: 'GET_FOLLOWING_SUCCESS',

    GET_DELETED_USERS: 'GET_DELETED_USERS',
    GET_DELETED_USERS_SUCCESS: 'GET_DELETED_USERS_SUCCESS',
    CHANGE_APP_PASSWORD: 'CHANGE_APP_PASSWORD',
    CHANGE_APP_PASSWORD_SUCCESS: 'CHANGE_APP_PASSWORD_SUCCESS',

    UPDATE_AUTO_FOLLOW: 'UPDATE_AUTO_FOLLOW',
    UPDATE_AUTO_FOLLOW_SUCCESS: 'UPDATE_AUTO_FOLLOW_SUCCESS',

    CHANGE_ADVERTISE_STATUS: 'CHANGE_ADVERTISE_STATUS',
    CHANGE_ADVERTISE_STATUS_SUCCESS: 'CHANGE_ADVERTISE_STATUS_SUCCESS',

};

export const UI = {
    MESSAGE:'MESSAGE',
    SHOW_LOADING:'SHOW_LOADING',
    SHOW_MAIN_LOADING:'SHOW_MAIN_LOADING',
    SHOW_GOOGLE_LOADING:'SHOW_GOOGLE_LOADING',
    SHOW_GOOGLE_GRAPH_LOADING:'SHOW_GOOGLE_GRAPH_LOADING',
    SELECT_GROUP_ID:'SELECT_GROUP_ID',
    SHOW_TOP_SEARCHES_LOADING:'SHOW_TOP_SEARCHES_LOADING',
    PROFILE_LOADING:'PROFILE_LOADING',
    FAILED_URLS_LOADING:'FAILED_URLS_LOADING',
    GOOGLE_ACTIVE_GRAPH:'GOOGLE_ACTIVE_GRAPH',
    PAGE_LOADING:'PAGE_LOADING',
    DASHBOARD_ACTIVE_TAB:'DASHBOARD_ACTIVE_TAB',
    EXPANDED_ROW:'EXPANDED_ROW',
    CAMPAIGN_FILTERS:'CAMPAIGN_FILTERS'
}

export const DASHBOARD = {
    GET_ANALYTICS:'GET_ANALYTICS',
    GET_ANALYTICS_SUCCESS:'GET_ANALYTICS_SUCCESS',
    GET_GOOGLE_ANALYTICS:'GET_GOOGLE_ANALYTICS',
    GET_GOOGLE_ANALYTICS_SUCCESS:'GET_GOOGLE_ANALYTICS_SUCCESS',
    GET_GOOGLE_ANALYTICS_GRAPH:'GET_GOOGLE_ANALYTICS_GRAPH',
    GET_GOOGLE_ANALYTICS_GRAPH_SUCCESS:'GET_GOOGLE_ANALYTICS_GRAPH_SUCCESS',
    GET_TOP_SEARCHES:'GET_TOP_SEARCHES',
    GET_TOP_SEARCHES_SUCCESS:'GET_TOP_SEARCHES_SUCCESS',

    GET_CAMPAIGNS_ANALYTICS:'GET_CAMPAIGNS_ANALYTICS',
    GET_CAMPAIGNS_ANALYTICS_SUCCESS:'GET_CAMPAIGNS_ANALYTICS_SUCCESS',
    GET_TRANSACTIONS_GRAPH_DATA:'GET_TRANSACTIONS_GRAPH_DATA',
    GET_TRANSACTIONS_GRAPH_DATA_SUCCESS:'GET_TRANSACTIONS_GRAPH_DATA_SUCCESS',

    GET_ACTIVE_CAMPAIGNS_MAP_DATA:'GET_ACTIVE_CAMPAIGNS_MAP_DATA',
    GET_ACTIVE_CAMPAIGNS_MAP_DATA_SUCCESS:'GET_ACTIVE_CAMPAIGNS_MAP_DATA_SUCCESS',
    GET_FAILED_URLS_DATA:'GET_FAILED_URLS_DATA',
    GET_FAILED_URLS_DATA_SUCCESS:'GET_FAILED_URLS_DATA_SUCCESS',

    SAVE_DASHBOARD_WIDGET:'SAVE_DASHBOARD_WIDGET',
    SAVE_DASHBOARD_WIDGET_SUCCESS:'SAVE_DASHBOARD_WIDGET_SUCCESS',
    GET_DASHBOARD_WIDGET:'GET_DASHBOARD_WIDGET',
}

export const POSTS = {
    GET_REPORTED_POSTS:'GET_REPORTED_POSTS',
    GET_REPORTED_POSTS_SUCCESS:'GET_REPORTED_POSTS_SUCCESS',
    GET_SEARCHES:'GET_SEARCHES',
    GET_SEARCHES_SUCCESS:'GET_SEARCHES_SUCCESS',
    GET_FAVOURITES:'GET_FAVOURITES',
    GET_FAVOURITES_SUCCESS:'GET_FAVOURITES_SUCCESS',

    REPORTED_BY:'REPORTED_BY',
    REPORTED_BY_SUCCESS:'REPORTED_BY_SUCCESS',
    VIEWED_BY:'VIEWED_BY',
    VIEWED_BY_SUCCESS:'VIEWED_BY_SUCCESS',
    POST_DETAILS:'POST_DETAILS',
    POST_DETAILS_SUCCESS:'POST_DETAILS_SUCCESS',
    DELETE_POST:'DELETE_POST',
    DELETE_POST_SUCCESS:'DELETE_POST_SUCCESS',
}

export const USERS_GROUPS = {
    ADD_GROUPS: 'ADD_GROUPS',
    ADD_GROUPS_SUCCESS: 'ADD_GROUPS_SUCCESS',
    LIST_GROUPS: 'LIST_GROUPS',
    LIST_GROUPS_SUCCESS: 'LIST_GROUPS_SUCCESS',
    GET_GROUPS_ARRAY: 'GET_GROUPS_ARRAY',
    GET_GROUPS_ARRAY_SUCCESS: 'GET_GROUPS_ARRAY_SUCCESS',
    ASSIGN_USER_GROUPS: 'ASSIGN_USER_GROUPS',
    ASSIGN_USER_GROUPS_SUCCESS: 'ASSIGN_USER_GROUPS_SUCCESS'
};

export const GROUPS_PERMISSIONS = {
    GET_PERMISSIONS:'GET_PERMISSIONS',
    GET_PERMISSIONS_SUCCESS:'GET_PERMISSIONS_SUCCESS',
    UPDATE_PERMISSIONS:'UPDATE_PERMISSIONS',
    UPDATE_PERMISSIONS_SUCCESS:'UPDATE_PERMISSIONS_SUCCESS'
}

export const CHAT = {
    GET_ROOMS:'GET_ROOMS',
    GET_ROOMS_SUCCESS:'GET_ROOMS_SUCCESS',
    GET_MESSAGES:'GET_MESSAGES',
    GET_MESSAGES_SUCCESS:'GET_MESSAGES_SUCCESS',
    ACCESS_REQUEST:'ACCESS_REQUEST',
    ACCESS_REQUEST_SUCCESS:'ACCESS_REQUEST_SUCCESS'
}

export const USERS_PERMISSIONS = {
    GET_USER_PERMISSIONS:'GET_USER_PERMISSIONS',
    GET_USER_PERMISSIONS_SUCCESS:'GET_USER_PERMISSIONS_SUCCESS',
    UPDATE_USER_PERMISSIONS:'UPDATE_USER_PERMISSIONS',
    UPDATE_USER_PERMISSIONS_SUCCESS:'UPDATE_USER_PERMISSIONS_SUCCESS'
}

export const FAILED_URLS = {
    GET_FAILED_URLS:'GET_FAILED_URLS',
    GET_FAILED_URLS_SUCCESS:'GET_FAILED_URLS_SUCCESS',
    GET_FAILED_URLS_FREQUENCY:'GET_FAILED_URLS_FREQUENCY',
    GET_FAILED_URLS_FREQUENCY_SUCCESS:'GET_FAILED_URLS_FREQUENCY_SUCCESS'
    
}

export const SETTINGS = {
    SAVE_SETTING:'SAVE_SETTING',
    SAVE_SETTING_SUCCESS:'SAVE_SETTING_SUCCESS',
    GET_SETTING:'GET_SETTING',
    GET_SETTING_SUCCESS:'GET_SETTING_SUCCESS',
    SAVE_APP_VERSION_SETTING:'SAVE_APP_VERSION_SETTING',
    SAVE_APP_VERSION_SETTING_SUCCESS:'SAVE_APP_VERSION_SETTING_SUCCESS',
    GET_APP_VERSION_SETTING:'GET_APP_VERSION_SETTING',
    GET_APP_VERSION_SETTING_SUCCESS:'GET_APP_VERSION_SETTING_SUCCESS',
}

export const CAMPAIGNS = {
    GET_CAMPAIGNS:'GET_CAMPAIGNS',
    GET_CAMPAIGNS_SUCCESS:'GET_CAMPAIGNS_SUCCESS',
    GET_CAMPAIGNS_DATA:'GET_CAMPAIGNS_DATA',
    GET_CAMPAIGNS_DATA_SUCCESS:'GET_CAMPAIGNS_DATA_SUCCESS',
    CHANGE_STATUS:'CHANGE_STATUS',
    CHANGE_STATUS_SUCCESS:'CHANGE_STATUS_SUCCESS',

    GET_CAMPAIGN_CHARGES:'GET_CAMPAIGN_CHARGES',
    GET_CAMPAIGN_CHARGES_SUCCESS:'GET_CAMPAIGN_CHARGES_SUCCESS',
    SAVE_CAMPAIGN_CHARGES:'SAVE_CAMPAIGN_CHARGES',
    SAVE_CAMPAIGN_CHARGES_SUCCESS:'SAVE_CAMPAIGN_CHARGES_SUCCESS',


    GET_INTEREST:'GET_INTEREST',
    GET_INTEREST_SUCCESS:'GET_INTEREST_SUCCESS',
    SAVE_INTEREST:'SAVE_INTEREST',
    SAVE_INTEREST_SUCCESS:'SAVE_INTEREST_SUCCESS',

    DELETE_INTEREST:'DELETE_INTEREST',
    DELETE_INTEREST_SUCCESS:'DELETE_INTEREST_SUCCESS',

    GET_TRANSACTION_HISTORY:'GET_TRANSACTION_HISTORY',
    GET_TRANSACTION_HISTORY_SUCCESS:'GET_TRANSACTION_HISTORY_SUCCESS',

    GET_CAMPAIGN_USER:'GET_CAMPAIGN_USER',
    GET_CAMPAIGN_USER_SUCCESS:'GET_CAMPAIGN_USER_SUCCESS',

    APPROVE_CAMPAIGN:'APPROVE_CAMPAIGN',
    APPROVE_CAMPAIGN_SUCCESS:'APPROVE_CAMPAIGN_SUCCESS',


    SAVE_CAMPAIGN_SETTING:'SAVE_CAMPAIGN_SETTING',
    SAVE_CAMPAIGN_SETTING_SUCCESS:'SAVE_CAMPAIGN_SETTING_SUCCESS',

    GET_CAMPAIGN_SETTING:'GET_CAMPAIGN_SETTING',
    GET_CAMPAIGN_SETTING_SUCCESS:'GET_CAMPAIGN_SETTING_SUCCESS',

    DELETE_CAMPAIGN_SETTING:'DELETE_CAMPAIGN_SETTING',
    DELETE_CAMPAIGN_SETTING_SUCCESS:'DELETE_CAMPAIGN_SETTING_SUCCESS',

    GET_CAMPAIGN_INSIGHT:'GET_CAMPAIGN_INSIGHT',
    GET_CAMPAIGN_INSIGHT_SUCCESS:'GET_CAMPAIGN_INSIGHT_SUCCESS',
}

export const NOTIFICATIONS = {
    SEND_NOTIFICATION:'SEND_NOTIFICATION',
    SEND_NOTIFICATION_SUCCESS:'SEND_NOTIFICATION_SUCCESS',
}

export const DIRECT_MESSAGE = {
    SEND_DIRECT_MESSAGE:'SEND_DIRECT_MESSAGE',
    DIRECT_MESSAGE_SUCCESS:'DIRECT_MESSAGE_SUCCESS',

    FETCH_DIRECT_MESSAGE:'FETCH_DIRECT_MESSAGE',
    FETCH_DIRECT_MESSAGE_SUCCESS:'FETCH_DIRECT_MESSAGE_SUCCESS',
}



export const SIGNUP_CODE = {

    GET_SIGNUP_CODES:'GET_SIGNUP_CODES',
    GET_SIGNUP_CODES_SUCCESS:'GET_SIGNUP_CODES_SUCCESS',

    SAVE_SIGNUP_CODE:'SAVE_SIGNUP_CODE',
    SAVE_SIGNUP_CODE_SUCCESS:'SAVE_SIGNUP_CODE_SUCCESS',

    DELETE_SIGNUP_CODE:'DELETE_SIGNUP_CODE',
    DELETE_SIGNUP_CODE_SUCCESS:'DELETE_SIGNUP_CODE_SUCCESS',
}


